import React, { useState, useEffect, useRef, useMemo } from 'react';
import classNames from 'classnames';
import Carousel from 'react-bootstrap/Carousel';
import { Loader } from '../../../components';
import { arrowLeftIcon, arrowRightIcon } from '../../assets/index';
import Button from '../../../components/button/index';
import chunk from 'lodash/chunk';
import ReviewCard from '../review-card';
import './styles.scss';

const cardsPerSlide = 3;
const getSlidesCollection = reviews => chunk(reviews, cardsPerSlide);

const ReviewsCarousel = ({ reviews, isLoading }) => {
  const carouselRef = useRef(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [indicators, setIndicators] = useState([]);

  const slideNext = () => {
    carouselRef.current.next();
  };

  const slidePrev = () => {
    carouselRef.current.prev();
  };

  const handleOnSlide = activeSlideIndex => {
    setActiveSlideIndex(activeSlideIndex);
    setIndicators([
      ...indicators.map((indicator, index) =>
        index === activeSlideIndex ? { ...indicator, isActive: true } : { ...indicator, isActive: false },
      ),
    ]);
  };

  const slidesCollection = useMemo(() => getSlidesCollection(reviews), [reviews]);

  const disabledPrevControl = activeSlideIndex === 0;
  const disabledNextControl = activeSlideIndex === slidesCollection.length - 1;

  useEffect(() => {
    setIndicators(
      [...new Array(slidesCollection.length)].map((item, index) =>
        index === 0 ? { isActive: true } : { isActive: false },
      ),
    );
  }, [slidesCollection]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="reviews-carousel">
      <Carousel
        ref={carouselRef}
        interval={null}
        controls={false}
        indicators={false}
        touch={false}
        wrap={false}
        onSlide={handleOnSlide}
      >
        {slidesCollection.map((slideReviews, index) => (
          <Carousel.Item key={index}>
            <div className="reviews-carousel__slide-wrapper">
              {slideReviews.map((review, index) => (
                <ReviewCard key={index} review={review} />
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      {slidesCollection?.length > 1 && (
        <div className="reviews-carousel__indicators-and-controls-wrapper">
          <div className="reviews-carousel__indicators-wrapper">
            {indicators.map((indicator, index) => (
              <div
                key={index}
                className={classNames('reviews-carousel__indicator', {
                  'reviews-carousel__indicator_active': indicator.isActive,
                })}
              />
            ))}
          </div>
          <div className="reviews-carousel__controls-wrapper">
            <Button
              type="green"
              className={classNames(
                'reviews-carousel__control',
                disabledPrevControl && 'reviews-carousel__control_disabled',
              )}
              text={<img src={arrowLeftIcon} alt="switch-previous" />}
              onClick={slidePrev}
              disabled={disabledPrevControl}
            />
            <Button
              type="green"
              className={classNames(
                'reviews-carousel__control',
                disabledNextControl && 'reviews-carousel__control_disabled',
              )}
              text={<img src={arrowRightIcon} alt="switch-next" />}
              onClick={slideNext}
              disabled={disabledNextControl}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewsCarousel;
